export function Logout() {
  return <>Logout</>;
}
